import React from 'react';
import { GatsbyImage, getImage, ImageDataLike } from 'gatsby-plugin-image';
import { KiteIcon } from '@kite/react-kite';
import { SmartLink } from '../SmartLink/SmartLink';
import './VideoCardTrioCard.scss';

export interface VideoCardTrioCard {
    /** Unique id for the card */
    id: string;
    /** Optional image for the card. Should be a reference to the image node's localFile. */
    image?: ImageDataLike;
    /** Alt text for the card image. Required if an image is included. */
    imageAlt?: string;
    /** Title for the card */
    title?: string;
    /** Secondary, smaller text for the card.  */
    description?: string;
    /** Where the user will be navigated if the card is clicked. */
    linkUrl?: string;
    /** The text for the link. This text will not be visible on screen if "news" is true. */
    linkText?: string;
    /** Onclick handler */
    onClick?: () => void;
}

export const VideoCardTrioCard: React.FC<{ card: VideoCardTrioCard }> = ({
    card,
}) => {
    const gImage = card.image ? getImage(card.image) : undefined;
    const InnerText = () => (
        <>
            {card.title && <h3 className="typestack-title-6">{card.title}</h3>}
            {card.description && (
                <div className="desc typestack-body-2">
                    <p>{card.description}</p>
                </div>
            )}
        </>
    );

    return (
        <li className="paragraph__video_card_trio_card" aria-live="polite">
            {<InnerText />}

            {card.linkUrl && (
                <SmartLink
                    url={card.linkUrl}
                    onClick={card.onClick}
                    classNames={[`watch-link`]}
                    ariaLabel={`Watch the video titled: ${card.title}`}
                    newWindow
                >
                    {card.linkText ?? `Watch Video`}
                    <KiteIcon icon="ki-arrow-right" size="1rem" />
                </SmartLink>
            )}
            {card.image && (
                <GatsbyImage
                    image={gImage}
                    alt={card.imageAlt ? card.imageAlt : ``}
                />
            )}
        </li>
    );
};
